import { formatNumber } from 'react-redux-app/lib/modules/i18n/utils';

import {
  currencySignMap,
  CURRENCY_EUR,
  CURRENCY_CRD,
  CURRENCY_USD,
} from '../constants';


const formatCRD = money => formatNumber(money.amount, 2);

const formatEUR = money => {
  const amount = formatNumber(money.amount, 2);
  return `${amount} ${currencySignMap[money.currency]}`;
};

const formatUSD = money => {
  const amount = formatNumber(money.amount, 2);
  return `${currencySignMap[money.currency]} ${amount}`;
};

const moneyFormatterMap = {
  [CURRENCY_CRD]: formatCRD,
  [CURRENCY_EUR]: formatEUR,
  [CURRENCY_USD]: formatUSD,
};

/**
 * format money to string like as "2 000.00 €", "200.50 €"
 * @param {Object} money
 * @param {Number} money.amount float value.
 * @param {String} money.currency (EUR, USD, CREDITS...)
 * @return {String}
 */

export default money => moneyFormatterMap[money.currency](money);
